import React from 'react';
import '../root.css';
import '../css/HeattrackPage.css';
import SEO from '../components/SEO';
import Typewriter from 'typewriter-effect';
import Navigation from '../components/sections/Navigation';
import { TextGenerateEffect } from '../components/ui/text-generate-effect';
import ContactSection from '../components/sections/ContactSection';

function HeattrackPage() {
  return (
    <>
      <SEO
        title="HeatTrack - IoT Heating Monitoring & AI Analytics | Samuel Banczík"
        description="HeatTrack is an intelligent system built by Samuel Banczík that uses sensors and a web application to monitor, predict and analyse indoor and outdoor temperatures, heat consumption and heating costs."
        keywords="HeatTrack, IoT, heating monitoring, temperature sensors, heat consumption, energy management, AI data analysis, Samuel Banczík"
        url="https://banczik.com/heattrack"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "HeatTrack",
          // The entity lives on its own deployment; this page only describes it.
          "url": "https://heattrack-production.up.railway.app/",
          "sameAs": "https://heattrack-production.up.railway.app/",
          "mainEntityOfPage": "https://banczik.com/heattrack",
          "applicationCategory": "BusinessApplication",
          "operatingSystem": "Web",
          "author": {
            "@type": "Person",
            "name": "Samuel Banczík",
            "url": "https://banczik.com"
          },
          "description": "IoT and AI system for monitoring and predicting temperatures, heat consumption and heating costs",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://banczik.com/" },
              { "@type": "ListItem", "position": 2, "name": "HeatTrack", "item": "https://banczik.com/heattrack" }
            ]
          }
        }}
      />
      <div className='heattrack-page'>
        <section className='heattrack-hero'>
          <img
            src="/images/background1.svg"
            alt='vector graphic'
            className='heattrack-hero-bg'
          />
          <Navigation darkLogo={false} />
          <div className='heattrack-hero-text'>
            <h1>
              <Typewriter
                options={{
                  strings: ['HEATTRACK'],
                  cursorStyle: "_",
                  autoStart: true,
                  loop: false,
                  deleteSpeed: Infinity,
                }}
              />
            </h1>
          </div>
        </section>

        <section id='works' className='heattrack-container'>
          <div className='heattrack-content'>
            <div className='heattrack-text'>
              <div className='heattrack-heading'>
                <h1>MY <span className='special-font' style={{ fontStyle: 'italic' }}>PROJECT</span></h1>
                <TextGenerateEffect
                  words='An Intelligent Monitoring System Built To Track Temperatures, Predict Trends And Visualize Real-Time Heat Consumption.'
                />
              </div>
            </div>
            <div className='heattrack-grid'>
              {/* <div className='heattrack-image-card'>
                <img src='/images/heattrackpc.png' alt='Heattrack dashboard desktop view' />
              </div>
              <div className='heattrack-image-card'>
                <img src='/images/heattrackpc2.png' alt='Heattrack analytics desktop view' />
              </div>
              <div className='heattrack-image-card'>
                <img src='/images/heattrack.png' alt='Heattrack app preview' />
              </div>
              <div className='heattrack-image-card'>
                <img src='/images/heattrack2.png' alt='Heattrack metrics view' />
              </div>
              <div className='heattrack-image-card'>
                <img src='/images/heattrack3.png' alt='Heattrack detailed screen' />
              </div>
              <div className='heattrack-image-card'>
                <img src='/images/heattracklogo2.svg' alt='Heattrack branding preview' />
              </div> */}
            </div>
          </div>
        </section>
      </div>
      <ContactSection />
    </>
  )
}

export default HeattrackPage